module.exports = __webpack_public_path__ + "static/media/DFPlates.d4c27feb.jpg";